import { CATEGORY_CHOICES } from '@constants/vatReturns';

import { filterAddOrEdit } from './helpers';

/**
 * File shape
 * @typedef {Object} File
 * @param {string} id - unique identifier
 * @param {string} name - file name
 * @param {string} [date] - game changer file date
 * @param {string} [savedFilingPeriod] - saved filing period unique identifier
 * @param {string} [uploadedBy] - unique identifies user who uploaded
 * @param {string} [category] - document category
 * @param {string} [extension] - document extension
 * @param {string} [sizeDisplay] - document size
 * @param {Date} [dateCreated] - document creation date
 * @param {Date} [dateUploaded] - online spreadsheet file date uploaded
 * @param {Date} [dateModified] - online spreadsheet file date modified
 * @param {string} [standardTemplate] - standard template unique identifier
 * @param {bool} sourceHasBeenProcessed - has the source file been processed?
 */

/**
 * Builds processing request data
 * @param {Array<File>} files - working files
 * @param {string} standardTemplateId - selected standard template id
 * @param {Array<File>} spreadsheets - online spreadsheets list
 * @param {Object<gameChangerOutputFiles, Array<File>>} selectedOutputFiles - game changer data
 * @param {boolean} isNilReturn - is filing set to nil return?
 * @param {Array<*>} relationshipList - relationship files list
 * @param {string} type - add or upload
 * @returns {{jsonList, isNilReturn, gcFileList: unknown[], relationshipList, id, type, fileList}}
 */
export const processFilesModel = ({
  files,
  standardTemplateId,
  spreadsheets,
  selectedOutputFiles,
  isNilReturn,
  relationshipList,
  type,
} = {}) => {
  const gcFileList = selectedOutputFiles?.gameChangerOutputFiles?.map(file =>
    filterAddOrEdit(file, type)
  );

  // eslint-disable-next-line array-callback-return
  const fileList = files?.map(file => {
    if (
      file.category === CATEGORY_CHOICES.CALCULATIONS ||
      file.category === CATEGORY_CHOICES.POST_CONVERSION
    ) {
      return filterAddOrEdit(file, type);
    }
  });
  const jsonList = spreadsheets?.map(file => filterAddOrEdit(file, type));

  return {
    fileList,
    jsonList,
    id: standardTemplateId,
    gcFileList,
    relationshipList,
    type,
    isNilReturn,
  };
};
